<template>
    <div>
        <template v-for="(proAchievement, paIndex) in studentAchievementData">
            <div class="card" :class="{'mt-3': paIndex !== 0}">
                <div class="card-header">
                    {{proAchievement.achievementName}}
                </div>
                <div class="card-body" v-if="proAchievement.studentAchievementData.length === 0">
                    <div class="alert alert-warning mb-0">没有【{{proAchievement.achievementName}}】成果物文件</div>
                </div>
                <table v-else class="table table-bordered mb-0">
                    <thead>
                    <tr>
                        <th class="text-center align-middle" style="width: 10%">序号</th>
                        <th class="text-center align-middle" style="width: 40%">文件名</th>
                        <th class="text-center align-middle" style="width: 20%">文件类型</th>
                        <th class="text-center align-middle" style="width: 30%">备注</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(file, index) in proAchievement.studentAchievementData" :key="file.attFileId">
                        <td class="text-center align-middle">{{ index + 1 }}</td>
                        <td class="text-left align-middle">
                            <a :href="URL_DOWNLOAD + file.attFileId" target="_blank">{{ file.sourceFileName }}</a>
                        </td>
                        <td class="text-center align-middle">{{ file.attFileCategoryName }}</td>
                        <td class="text-left align-middle">{{ file.memo }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </template>
    </div>
</template>

<script>
import studyApi from "@/utils/api/study";
import dictionary from "@/utils/dictionary";
import commonApi from "@/utils/api/common";
import url from "@/utils/api/url";
export default {
    name: "StudentAchievmentView",
    props: {
        projectId: {type: String, required: true},

        studentId: {type: String, required: true},
    },
    data: function () {
        return {
            URL_DOWNLOAD: url.URL_DOWNLOAD,
            attFileType: dictionary.attFileType,

            studentAchievementData: [],
        };
    },
    mounted() {
        this.getStudentAchievementDataByStudentId();
    },
    methods: {
        getStudentAchievementDataByStudentId() {
            studyApi.achievement.getStudentAchievementDataByStudentId(this.studentId, this.projectId).then(res => {
                this.studentAchievementData = res.data;
            });
        },
    }
}
</script>

<style scoped>

</style>